'use client';

import { useTranslations } from 'next-intl';

export function LoadingFallback() {
  const t = useTranslations('loading');

  return (
    <div className="flex h-full items-center justify-center">
      <div className="text-muted-foreground">{t('assistant')}</div>
    </div>
  );
}
